import Repository from "../Repository";

const resource = "/modules";
export default {
    get(){
        return Repository.get(`${resource}`);
    },
    getModuleTemplates(){
        return Repository.get(`${resource}?is_template=1`);
    },
    getModule(moduleId){
        return Repository.get(`${resource}/${moduleId}`);
    },
    createModule(json){
        return Repository.post(`${resource}`,json);
    },
    copyModule(moduleId){
        return Repository.post(`${resource}/${moduleId}/copy`);
    },
    updateModule(moduleId,json){
        return Repository.put(`${resource}/${moduleId}`,json);
    },
    deleteModule(moduleId){
        return Repository.delete(`${resource}/${moduleId}`);
    }
}